import { LoaderSwitcher, PartnerStoreLoader } from 'router/loaders'
import { Checkout } from '../../shop/pages'
import { CheckoutCartLoader } from 'router/loaders'

export const CheckoutWrapper = () => {
  return (
    <CheckoutCartLoader>
      {(isParentLoaded, cart) => (
        <PartnerStoreLoader
          storeSlug={cart.store.slug}
          isParentLoaded={isParentLoaded}
        >
          {(isParentLoaded) => (
            <LoaderSwitcher isParentLoaded={isParentLoaded}>
              <Checkout />
            </LoaderSwitcher>
          )}
        </PartnerStoreLoader>
      )}
    </CheckoutCartLoader>
  )
}
